<template>
  <div class="filter">
    <header class="filter-header">
      <div class="filter-header__title">答题情况</div>
      <el-select v-model="value" placeholder="请选择" @change="changeFilter">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </header>
    <div class="chart-legend">
      <span
        class="fx"
        v-for="(item, index) in legendList"
        :key="index">
        <span :style="{'background-color': item.color}" class="chart-legend__dot"></span>
        <span>{{item.name}}</span>
      </span>
    </div>
    <div class="filter-br"></div>
    <div
      v-for="(item, index) in showTitleList"
      :key="index"
      class="filter-topic">
      <div class="filter-topic__title" v-if="item.k_module_name !== ''">
        {{item.k_module_name}}
      </div>
      <div>
        <div
          class="filter-topic__serialNumber"
          v-for="kitem in item.question_list"
          :key="kitem.question_id"
        >
          <div class="filter-topic__serialNumber__name attention"
          @click="jumpTopic(kitem, item)"
          :class="{
            'attention': kitem.right_rate < 60,
            'regular': kitem.right_rate >= 60 && kitem.right_rate < 80,
            'well': kitem.right_rate >= 80 && kitem.right_rate < 90,
            'excellent': kitem.right_rate >= 90,
            'is-attention': kitem.right_rate < 60 && kitem.isactive,
            'is-regular': kitem.right_rate >= 60 && kitem.right_rate < 80 && kitem.isactive,
            'is-well': kitem.right_rate >= 80 && kitem.right_rate < 90 && kitem.isactive,
            'is-excellent': kitem.right_rate >= 90 && kitem.isactive
          }"
          >
            {{kitem.sort}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopicFilter',
  props: {
    titleList: {
      type: Array,
      default: () => [],
    },
    questionId: {},
  },
  watch: {
    titleList: {
      handler() {
        this.showTitleList = this.titleList;
        this.showTitleList.forEach((item) => {
          console.log(item);
          item.question_list.sort((a, b) => a.sort - b.sort);
        });
        console.log(this.showTitleList, 'shuzu');
        this.pitchOn(this.questionId);
      },
      immediate: true,
    },
    questionId() {
      this.type = true;
    },
  },
  data() {
    return {
      options: [{
        value: '1',
        label: '按题号排序',
      }, {
        value: '2',
        label: '按正答排序',
      }],
      value: '1',
      legendList: [
        {
          name: '待关注',
          color: '#F56C6C',
        }, {
          name: '合格',
          color: '#F4C707',
        }, {
          name: '良好',
          color: '#1989FA',
        }, {
          name: '优秀',
          color: '#67C23A',
        }],
      type: false,
      showTitleList: [],
    };
  },
  methods: {
    pitchOn(id) {
      console.log(this.showTitleList, '数字');
      this.showTitleList.forEach((i) => {
        i.question_list.forEach((k) => {
          if (id === k.question_id) {
            console.log('有吗');
            this.$set(k, 'isactive', true);
            this.$emit('jumpTopic', k);
          }
        });
      });
    },
    changeFilter(val) {
      console.log(val);
      if (Number(val) === 2) {
        this.showTitleList.forEach((item) => {
          console.log(item);
          item.question_list.sort((a, b) => a.right_rate - b.right_rate);
        });
      } else {
        this.showTitleList.forEach((item) => {
          console.log(item);
          item.question_list.sort((a, b) => a.sort - b.sort);
        });
      }
    },
    jumpTopic(kitem) { // 选中题型状态
      this.showTitleList.forEach((i) => {
        i.question_list.forEach((k) => {
          this.$set(k, 'isactive', false);
        });
      });

      this.$set(kitem, 'isactive', true);
      this.$emit('jumpTopic', kitem);
      console.log(kitem, 'kitem');
    },
  },
};
</script>

<style lang="scss" scoped>
  .filter {
    margin-left: 10px;
    padding: 0px 16px 0 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: auto;
    &-header {
      display: flex;
      &__title {
        width: 150px;
        text-indent: 12px;
        align-self: center;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 40px;
        color: rgba(0, 0, 0, 0.8);
        background: url('../../images/class_bg.png') no-repeat left center;
      }
    }
    &-br {
      margin-top: 12px;
      border: 1px dashed #ccc;
    }
    &-topic {
      margin-top: 16px;
      &__title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 25px;
        margin-bottom: 16px;
        &::before {
          content: '';
          display: inline-block;
          width: 3px;
          height: 16px;
          margin-right: 10px;
          background: #1890FF;
          border-radius: 3px;
        }
      }
      &__serialNumber{
        display: inline-block;
        width: 20%;
        margin: 5px;
        &__name {
          width: 32px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          border-radius: 50%;
        }
      }
      .dis-in {
        display: inline-block;
      }
      .attention {
        border: 1px solid #F56C6C;
        color: #F56C6C;
        &:hover {
          background-color: #F56C6C;
          color: #fff;
        }
      }
      .is-attention {
        background-color: #F56C6C;
        color: #fff;
      }
      .regular {
        border: 1px solid #F4C707;
        color: #F4C707;
        &:hover {
          background-color: #F4C707;
          color: #fff;
        }
      }
      .is-regular {
        background-color: #F4C707;
        color: #fff;
      }
      .well {
        border: 1px solid #1989FA;
        color: #1989FA;
        &:hover {
            background-color: #1989FA;
            color: #fff;
          }
        }
        .is-well {
          background-color: #1989FA;
          color: #fff;
        }
      .excellent {
        border: 1px solid #67C23A;
        color: #67C23A;
        &:hover {
          background-color: #67C23A;
          color: #fff;
        }
      }
      .is-excellent {
        background-color: #67C23A;
        color: #fff;
        }
    }
  }
  .chart-legend {
    margin-top: 19px;
    display: flex;
    justify-content: space-around;
    &__dot {
      flex: 1;
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 5px;
      border-radius: 50%;
    }
  }
</style>
